module.exports = __webpack_public_path__ + "static/media/hs_03.46d790e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_03.jpg
// module id = 5934
// module chunks = 0